export const mountableSteps = {
	stepLabel: "Etapa",
	addStep: "Adicionar nova etapa",
	removeStep: "Excluir etapa",
	cardHeader: {
		titlePlaceholder: "Nome da etapa",
	},
	fields: {
		title: {
			label: "Título da etapa",
			placeholder: "Digite o nome que irá aparecer no PDV",
		},
		pricing: {
			label: "Precificação",
			placeholder: "Selecione a precificação",
			options: {
				sum: {
					label: "Valor adicional",
					tooltip: "Todo item adicionado será incrementado no valor do produto",
				},
				average: {
					label: "Média entre valores",
					tooltip: "A média dos itens selecionados será incrementada",
				},
				higher: {
					label: "Maior valor",
					tooltip: "O maior valor entre os itens será adicionado ao valor do produto",
				},
			},
		},
		min: {
			label: "Qtd min selecionável da etapa",
			tooltip: "Mínimo de itens a ser selecionado nesta etapa",
		},
		max: {
			label: "Qtd máx selecionável da etapa",
			tooltip: "Máximo de itens a ser selecionado nesta etapa",
		},
	},
	fiscalSplit: {
		enabled: "Divisão fiscal habilitada",
		disabled: "Divisão fiscal desabilitada",
		title: "DIVISÃO FISCAL",
		fiscalWeight: {
			label: "% Peso fiscal da etapa {{stepNumber}}",
			placeholder: "00%",
			info: "O peso (%) determina quanto essa etapa representa na nota fiscal.",
			supplyAlert: {
				title: "Existem alguns insumos nessa etapa",
				message:
					"Quando a etapa possui produtos e insumos, o peso fiscal (%) define apenas a participação dos produtos com dados fiscais na nota. Os insumos acima não possuem dados fiscais e não serão emitidos.",
			},
		},
		summary: {
			title: "Resumo fiscal",
			stepPrefix: "Etapa",
			incomplete: "distribua 100% entre as etapas",
		},
		dialog: {
			triggerLabel: "Saiba mais sobre divisão fiscal",
			title: "Divisão fiscal",
			paragraph1:
				"A divisão fiscal define como o valor total da nota fiscal é distribuído entre os itens do produto montável.",
			paragraph2: {
				intro:
					"Os pesos (%) das etapas determinam a participação dos produtos com dados fiscais na nota.",
				bold: "Insumos não possuem dados fiscais e não serão emitidos na nota final.",
			},
			example: {
				title: "Exemplo:",
				intro: "Uma caipirinha de R$ 20:",
				item1: "Base (70%) — cachaça (produto com dado fiscal): R$ 14",
				item2: "Complementos (30%) — açúcar (insumo) e limão (insumo): não são emitidos",
				conclusion: "Neste caso, apenas a cachaça participa da divisão do valor da nota.",
			},
			close: "Fechar",
			confirm: "Entendi",
		},
	},
	itemsSection: {
		title: "ITENS ADICIONAIS",
		addItem: "Adicionar outro item",
		removeItem: "Excluir item",
		clearItem: "Limpar item",
		fields: {
			item: {
				label: "Insumo/Produto",
				placeholder: "Selecione o insumo",
				loadingPlaceholder: "Carregando produtos...",
			},
			price: {
				label: "Valor",
			},
			maxCount: {
				label: "Qtd máx do item",
				placeholder: "0",
				tooltip: "Quantidade máxima de vezes que este item pode ser selecionado na etapa",
			},
			storageCount: {
				label: "Qtd abatida do item",
				placeholder: "0",
				tooltip: "Quantidade que será abatida do estoque por unidade",
			},
			isModification: {
				label: "Item de alteração",
			},
		},
	},
	actions: {
		delete: "Excluir produto montável",
		clear: "Limpar produto montável",
		deleteConfirmation: {
			title: "Excluir produto montável",
			description:
				"Ao confirmar a ação você exclui permanentemente o produto montável. Deseja continuar?",
			confirm: "Sim, desejo excluir",
			cancel: "Cancelar",
		},
		clearConfirmation: {
			title: "Limpar produto montável",
			description:
				"Ao confirmar a ação você limpa todos os dados do produto montável do formulário. Deseja continuar?",
			confirm: "Sim, desejo limpar",
			cancel: "Cancelar",
		},
		notifications: {
			deleteSuccess: "Produto montável removido com sucesso",
			deleteError: "Erro ao remover o produto montável",
		},
	},
	preview: {
		toggle: {
			pdv: "PDV",
			totem: "Totem",
		},
		productNameFallback: "Nome do produto",
		descriptionFallback:
			"Adicione uma descrição para o produto que será exibida no PDV ou no Totem.",
		seeMore: "Ver mais",
		requiredBadge: "Obrigatório",
		stepFallbackTitle: "Etapa {{n}}",
		itemFallbackName: "Item",
		chooseUpToOne: "Escolha até {{count}} item",
		chooseUpToMany: "Escolha até {{count}} itens",
		addCta: "Adicionar {{total}}",
		empty: {
			title: "Pré-visualização",
			description: "As etapas aparecerão aqui conforme você preencher o formulário.",
		},
		illustrativeNotice:
			"Esta é uma representação ilustrativa e pode diferir da exibição real no PDV ou Totem.",
		previewActionTooltip: "Apenas visualização — ações não estão disponíveis aqui.",
		expandPreview: "Expandir pré-visualização",
	},
};
